import Vue from "vue";

export const tokenObservable = Vue.observable({
  token: ""
});
